import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetPrescriptionLensesOutput } from './GetPrescriptionLensesOutput';

export class GetPrescriptionLensesService extends HttpServiceBase {

  handle = (): Promise<Result<GetPrescriptionLensesOutput> | null> => {
    const promise = this.http.get<Result<GetPrescriptionLensesOutput>>(`${this.baseUrlSislogApi}/v2/product/prescription-lenses`);
    return promise;
  }
}
